import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Button, Input, List, Avatar } from "antd";
import UserLogin from "./forms/UserLogin";
import { FuelPumpFill, CardHeading, PencilSquare, Truck, DropletHalf, GlobeEuropeAfrica } from 'react-bootstrap-icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Search = Input.Search;
var HomeContent = function HomeContent() {
  var data = [{
    title: 'Suiviez les ventes de carburant',
    avatar: /*#__PURE__*/_jsx(FuelPumpFill, {
      size: 30
    }),
    description: "Enrégistrez et numérisez vos nouveaux depuis le secretariat central"
  }, {
    title: 'Consultez les comptes rendu journaliers',
    avatar: /*#__PURE__*/_jsx(CardHeading, {
      size: 30
    }),
    description: "Trouvez et faites la lecture de vos courriers sur tout support mobile"
  }, {
    title: 'Entrez les operations de caisse',
    avatar: /*#__PURE__*/_jsx(PencilSquare, {
      size: 30
    }),
    description: "Manager, annotez des courriers à vos departements compétants et suivez"
  }, {
    title: "Passez vos et suivez commandes",
    avatar: /*#__PURE__*/_jsx(Truck, {
      size: 30
    }),
    description: "Transferez un courrier à plusieurs départements internes"
  }, {
    title: "Gardez un oeil sur votre cuve pour anticipez les commandes",
    avatar: /*#__PURE__*/_jsx(DropletHalf, {
      size: 30
    }),
    description: "Archivez vos courriers de manière infinie et rerouvez les en un clique"
  }, {
    title: "Pourtout ou vous vous trouvez",
    avatar: /*#__PURE__*/_jsx(GlobeEuropeAfrica, {
      size: 30
    }),
    description: "Le tout accessible en un clique, ou que vous soyez"
  }];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "page-container",
      children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 4,
            md: 4,
            sm: 4,
            children: /*#__PURE__*/_jsxs("div", {
              className: "home-right-box",
              children: [/*#__PURE__*/_jsx("div", {
                className: "hlogo",
                children: /*#__PURE__*/_jsx("img", {
                  src: "drawables/ss.png",
                  style: {
                    width: '100%'
                  }
                })
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
                style: {
                  borderRadius: '0px 18px 18px 18px',
                  padding: '20px',
                  background: "#09B6C9"
                },
                children: /*#__PURE__*/_jsx(UserLogin, {})
              })]
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: {
              span: 6,
              offset: 2
            },
            md: {
              span: 6,
              offset: 2
            },
            sm: 6,
            children: /*#__PURE__*/_jsxs("div", {
              className: "home-top-ads",
              children: [/*#__PURE__*/_jsx("h3", {
                children: "En un clique ... "
              }), /*#__PURE__*/_jsx(List, {
                itemLayout: "horizontal",
                dataSource: data,
                renderItem: function renderItem(item) {
                  return /*#__PURE__*/_jsx(List.Item, {
                    children: /*#__PURE__*/_jsx(List.Item.Meta, {
                      title: /*#__PURE__*/_jsx("b", {
                        children: item.title
                      }),
                      description: item.description,
                      avatar: item.avatar
                    })
                  });
                }
              }), /*#__PURE__*/_jsx("div", {
                children: /*#__PURE__*/_jsx("img", {
                  src: "/drawables/bus-station.png"
                })
              })]
            })
          })]
        })
      })]
    }), /*#__PURE__*/_jsx("br", {})]
  });
};
export default HomeContent;